<template>
    <div class="sigup-header-block">
        <div class="sigup-header-block--logoblock">
            <img src="../../../assets/arpn-logo.svg" />
        </div>
        <div class="sigup-header-block--documents">
        </div>
    </div>
</template>

<script>
export default {
    name: 'SignInHeaderBlock'
}
</script>


<style lang="scss" scoped>
    .sigup-header-block {
        display: flex;
        width: 100%;
        height: fit-content;
        justify-content: space-between;
        margin-top: 50px;
        &--logoblock {
            display: flex;
            img {
                width: 120px;
                height: 120px;
            }
        }
        &--documents {
            display: flex;
            flex-direction: row;
            gap: 15px;
            &--item {
                display: flex;
                flex-direction: column;
                cursor: pointer;
                width: 70px;
                height: 70px;
                &--logo {
                    display: flex;
                    width: 70px;
                }
                &--text {
                    font-size: 12px;
                    line-height: 18px;
                    color: #fff;
                    text-align: center;
                }
            }
        }
    }

    .sigup-header-block--documents--item:hover > .sigup-header-block--documents--item--text {
        text-decoration: underline;
    }
</style>
